import {ICard} from "../../types/cardType";
import analytics from "./analytics";
import {cardToItem} from "./gtagUtilities";

const getCardName = (card: ICard): string => {
    return card.service_name || card.card_id || ''
}

const cardEvent = (
    card: ICard,
    index: number,
    select: boolean,
) => {
    if (select) {
        analytics.logEvent({
            event: 'select_item',
            params: {
                ecommerce: {
                    items: [cardToItem(card, index)],
                },
            },
        });
    } else {
        const eventParams = {
            card_id: card.card_id,
            card_name: getCardName(card),
            card_org: card.organization_id,
            landing_page:analytics.getIsLandingPageAsString()
        };
        analytics.logEvent({
            event: 'view_item',
            params: {
                ...eventParams,
                items: [cardToItem(card, index)],
            },
        });
    }
};

const addToCartEvent = (card: ICard, action: string, action_url: string) => {
    const eventParams = {
        action_type: action,
        action_url: action_url,
        card_id: card.card_id,
        card_name: getCardName(card),
        card_org: card.organization_id,
        cta_action: action,
        landing_page: analytics.getIsLandingPageAsString,
        items: [cardToItem(card, 0)],
    };
    analytics.logEvent({
        event: 'add_to_cart',
        params: {
            conversion: true,
            ...eventParams,
        },
    });
};

const cardActionEvent = (card: ICard, action: string, action_url: string) => {
    const eventParams = {
        action_type: action,
        action_url: action_url,
        card_id: card.card_id,
        card_name: getCardName(card),
        card_org: card.organization_id,
        landing_page: 'no',
    };
    analytics.logEvent({
        event: 'card_action',
        params: eventParams,
    });
};

const copyToClipboard = ({card, action, action_url}: {
                             card: ICard,
                             action: 'email' | 'phone' | 'url' | 'nav',
                             action_url: string
                         }
) => {
    addToCartEvent(card, action, action_url);
    cardActionEvent(card, action, action_url);
};

const extendDescriptionEvent = (card_id: string) => {
    analytics.logEvent({
        event: 'srm:extend_description',
        params: {card_id},
    });
};

const shrinkDescriptionEvent = (card_id: string) => {
    analytics.logEvent({
        event: 'srm:shrink_description',
        params: {card_id},
    });
};

const clickOnLabelEvent = ({cardId, labelId, labelName}: { cardId: string, labelId: string, labelName: string}) => {
    analytics.logEvent({
        event:'click_on_label',
        params:{
            card_id:cardId,
            label_id:labelId,
            label_name:labelName,
        }
    })
};

export default {
    cardEvent,
    addToCartEvent,
    cardActionEvent,
    copyToClipboard,
    extendDescriptionEvent,
    shrinkDescriptionEvent,
    clickOnLabelEvent
}
